var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 290,
    viewBox: "0 0 24 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9393 289.061C11.5251 289.646 12.4749 289.646 13.0606 289.061L22.6066 279.515C23.1924 278.929 23.1924 277.979 22.6066 277.393C22.0208 276.808 21.0711 276.808 20.4853 277.393L12 285.879L3.51471 277.393C2.92892 276.808 1.97917 276.808 1.39339 277.393C0.807599 277.979 0.807599 278.929 1.39339 279.515L10.9393 289.061ZM10.5 -6.55671e-08L10.5 288L13.5 288L13.5 6.55671e-08L10.5 -6.55671e-08Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/Arrow 1.5fffac3b99220a300e9516b28395bab2.svg";
export { ForwardRef as ReactComponent };